import { render, staticRenderFns } from "./SubmissionHandler.vue?vue&type=template&id=ac21a1fc"
import script from "./SubmissionHandler.vue?vue&type=script&lang=js"
export * from "./SubmissionHandler.vue?vue&type=script&lang=js"
import style0 from "./SubmissionHandler.vue?vue&type=style&index=0&id=ac21a1fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports